export const validateToken = async ({ token, user, condominio }) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/validate-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, user, condominio }),
      });
  
      if (!response.ok) {
        throw new Error(`Erro ao validar token. Status: ${response.status}`);
      }
  
      const data = await response.json();
  
      // Processar e armazenar o usuário no sessionStorage
      const { role, password, ...filteredUser } = data.user;
      const userWithToken = { ...filteredUser, token }; // Inclui o token no objeto armazenado
  
      sessionStorage.setItem('user', JSON.stringify(userWithToken)); // Salvar no sessionStorage
  
      return userWithToken; // Retornar o usuário armazenado
    } catch (error) {
      throw error;
    }
  };
  